export default __webpack_public_path__ + "static/media/sociaalbxlnl.3f52dc9f.png";